import dayjs from "dayjs";

/** Utilidades de presentación del registro de jornada (#13709). */

/** «09:02» a partir de un LocalDateTime del API («2026-10-15T09:02:00»). */
export const hhmm = (dt?: string | null): string => dt ? dt.substring(11, 16) : "—";

/** «4 h 58 min» a partir de minutos. */
export const duration = (minutes?: number | null): string => {
	const m = Math.max(0, Math.round(minutes || 0));
	const h = Math.floor(m / 60);
	const r = m % 60;
	if (h === 0) {
		return `${r} min`;
	}
	return r === 0 ? `${h} h` : `${h} h ${r} min`;
};

/** «4,5 h» a partir de horas decimales. */
export const hours = (h?: number | null): string =>
	`${(h || 0).toLocaleString("es-ES", {minimumFractionDigits: 1, maximumFractionDigits: 2})} h`;

/** «miércoles, 14 de octubre» */
export const longDay = (date?: string | null): string => {
	if (!date) {
		return "";
	}
	const s = dayjs(date).format("dddd, D [de] MMMM");
	return s.charAt(0).toUpperCase() + s.substring(1);
};

/** «14/10/2026» */
export const shortDay = (date?: string | null): string => date ? dayjs(date).format("DD/MM/YYYY") : "";

export const STATUS_LABEL: Record<string, string> = {
	OPEN: "Abierta",
	COMPLETE: "Completa",
	INCOMPLETE: "Incompleta",
	PENDING: "Pendiente",
	APPROVED: "Aprobada",
	REJECTED: "Rechazada",
};

export const STATUS_COLOR: Record<string, "default" | "success" | "warning" | "error" | "info"> = {
	OPEN: "info",
	COMPLETE: "success",
	INCOMPLETE: "warning",
	PENDING: "warning",
	APPROVED: "success",
	REJECTED: "error",
};

/** Sombra y radio comunes: los del kit (#13877). */
export {panelSx} from "../../../components/kit";
